__turbopack_context__.v({
  "isTabActive": "legacyTabs-module-scss-module__ebq7Hq__isTabActive",
  "isTabDisabled": "legacyTabs-module-scss-module__ebq7Hq__isTabDisabled",
  "tab": "legacyTabs-module-scss-module__ebq7Hq__tab",
  "tabCountLabel": "legacyTabs-module-scss-module__ebq7Hq__tabCountLabel",
  "tableTabs": "legacyTabs-module-scss-module__ebq7Hq__tableTabs",
  "tabsFooter": "legacyTabs-module-scss-module__ebq7Hq__tabsFooter",
});
